/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue'

// Composables
import { createApp, provide, h } from "vue"
// Plugins
import { registerPlugins } from '@/plugins'

import { DefaultApolloClient } from "@vue/apollo-composable"
import { apolloClient } from './apollo/client'

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import router from './router'

import * as Sentry from "@sentry/vue";

const app = createApp({

  setup() {

      provide(DefaultApolloClient, apolloClient)

  },

  render: () => h(App),

})



Sentry.init({
  app,
  dsn: "https://72243c8c475ad0b8e44b0cb30c876e43@o4506337914257408.ingest.sentry.io/4506337915568128",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],

  enabled: process.env.NODE_ENV !== 'development',

  environment: import.meta.env["VITE_ENVIRONMENT"],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/([^.]+)\.serod\.tech$/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});



registerPlugins(app)


app.component('VueDatePicker', VueDatePicker);

// VCalendar
app.use(VCalendar, {})

app.mount('#app')
